var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.items),function(item){return _c('b-col',{key:item.id,attrs:{"cols":"auto"}},[_c('StrapiLettreTechniqueComponent',{attrs:{"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }